import { analytics } from '@/config/posthog/analytics';
import { User } from '@/store/useUserStore';

const useAnalytics = () => {
  const trackEvent = (event: string, properties: object) => {
    analytics.track(event, properties);
  };

  const trackAuthEvent = async ({ user }: { user: User }) => {
    analytics.identify(user.email);
  };

  const logout = () => {
    analytics.reset();
  };

  return {
    trackEvent,
    trackAuthEvent,
    logout,
  };
};

export { useAnalytics };
